module.exports = __webpack_public_path__ + "img/icon-tasks-white.6a56357c.svg";